import React from 'react';

function SpeakerCrossedIcon({ width = 15, height = 15, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 15 15">
      <g>
        <path d="M3.81850196,9.61652689 L2.59513474,9.61652689 C2.26734376,9.61652689 2,9.33997863 2,9.00052455 L2,5.28450276 C2,4.94437045 2.26734376,4.66799175 2.59513474,4.66799175 L5.09083463,4.66799175 L9.52575969,1.20410194 C9.61487427,1.1340747 9.73544107,1.12220567 9.83585879,1.17459894 C9.9361127,1.22631397 10,1.33262651 10,1.44860383 L10,3.43502884 L13.2885822,0.146446609 C13.4838444,-0.0488155365 13.8004269,-0.0488155365 13.995689,0.146446609 C14.1909512,0.341708755 14.1909512,0.658291245 13.995689,0.853553391 L10,4.8492424 L10,12.8355757 C10,12.951553 9.9361127,13.0580351 9.83585879,13.1097501 C9.79392252,13.1314535 9.7490376,13.1421356 9.70366123,13.1421356 C9.64092063,13.1421356 9.5778524,13.1212801 9.52575969,13.0802471 L5.1704978,9.67874461 L0.853553391,13.995689 C0.658291245,14.1909512 0.341708755,14.1909512 0.146446609,13.995689 C-0.0488155365,13.8004269 -0.0488155365,13.4838444 0.146446609,13.2885822 L3.81850196,9.61652689 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default SpeakerCrossedIcon;
